import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import ColumnHeaderSpacedContent from './ColumnHeaderSpacedContent';
import I18n from 'I18n';
import { WorkflowsIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnIcon = ({
  columnData
}) => {
  const {
    icon,
    hasWorkflows
  } = columnData;
  const depricatedIconData = hasWorkflows ? {
    name: 'workflows',
    screenReaderText: I18n.text('customer-data-board.columnHasWorkflowIconText'),
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-data-board.columnHasWorkflowTooltip"
    }),
    IconComponent: WorkflowsIcon
  } : undefined;
  const iconDataToRender = icon || depricatedIconData;
  if (!iconDataToRender) {
    return null;
  }
  const IconComponent = iconDataToRender.name === 'workflows' ? WorkflowsIcon : iconDataToRender.IconComponent;
  if (!IconComponent) {
    return null;
  }
  return /*#__PURE__*/_jsx(ColumnHeaderSpacedContent, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: iconDataToRender.tooltip,
      disabled: !iconDataToRender.tooltip,
      placement: "bottom",
      children: /*#__PURE__*/_jsx(Flex, {
        as: "span",
        children: /*#__PURE__*/_jsx(IconHolder, {
          icon: IconComponent,
          size: "100",
          color: "icon-core-subtle",
          "aria-label": iconDataToRender === null || iconDataToRender === void 0 ? void 0 : iconDataToRender.screenReaderText,
          verticalAlign: "middle",
          padding: "0"
        })
      })
    })
  });
};
export default ColumnIcon;